module.exports = __webpack_public_path__ + "media/images/logo-shape-rotated-a93a9e419c123623aa6c0b89a2fd3466.svg";